import { createApp } from 'vue';
import App from '../components/Advices.vue';
import '../styles/index.scss';

createApp(App)
  .mount('#advices');
